import ptFlag from "../../../../img/ptFlag.png?width=50px";
import FlagOptionBase from "../../abstracts/flagOptionBase";
import flagItemModal from "./flagItem";

export default class PtFlagOpt extends FlagOptionBase{
    private static titleLegend = "Portugues";
    private static idOption = "op-pt";
    private static elementToRender = flagItemModal(ptFlag,PtFlagOpt.titleLegend);

    constructor(protected modalBody:HTMLElement){
        super(modalBody,PtFlagOpt.idOption,PtFlagOpt.elementToRender);
    }

    translateAction(){
        localStorage.setItem("i18n","pt");
    }
}